import { createContext, useContext, useState, ReactNode  } from 'react';
const materialsContextInfo = createContext<any>({});


export const MaterialsProvider = ({ children }: { children: ReactNode })=>{
      const [materialsArray, setMaterialsArray] = useState<{name: string}[]>([])
    return(
        <materialsContextInfo.Provider value={{materialsArray: materialsArray, setMaterialsArray: setMaterialsArray}}>
            {children}
        </materialsContextInfo.Provider>
    )
}

export const MaterialsConsumer = ()=>{
    return useContext(materialsContextInfo);
}
